export default __webpack_public_path__ + "static/media/calculator.64e133c6.PNG";